import React from "react";
import { Outlet } from "react-router-dom";
const CustomUsersNotifiComponent = () => {
    return (
        <>
            <Outlet />
        </>
    );
};
export default CustomUsersNotifiComponent
